import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IQuote, IQuotesResponse } from "../models/Quote";
import toQueryString from "../utils/toQueryString";

interface IQuoteFilters {
    step?: number;
    sellavehicle?: boolean | null;
    filterCustomerId?: string | null;
    /** ISO date-time; only quotes created on/after this are returned */
    from?: string | null;
    /** ISO date-time; only quotes created before this are returned */
    to?: string | null;
}

export default function useQuotes(filters: IQuoteFilters) {
    const { get, post, put, del } = useApiHelper();
    const queryClient = useQueryClient();

    // const accepted = useQuery({
    //     queryKey: ["quotes"],
    //     queryFn: () => get<IQuotesResponse>("/quote/accepted"),
    //     refetchInterval: 1000 * 10,
    // });

    // const missed = useQuery({
    //     queryKey: ["quotes"],
    //     queryFn: () => get<IQuotesResponse>("/quote/missed"),
    //     refetchInterval: 1000 * 10,
    // });

    const abandoned = useQuery({
        queryKey: ["quotes", filters],
        queryFn: () => get<IQuotesResponse>("/quote/abandoned" + toQueryString(filters)),
        refetchInterval: 1000 * 60 * 5 , // 5 minutes
    });

    const calculated = useQuery({
        queryKey: ["quotes", "calculated"],
        queryFn: () => get<IQuotesResponse>("/quote/calculated"),
        refetchInterval: 1000 * 60 * 5 , // 5 minutes
    });

   

    return {
        // accepted,
        // missed,
        abandoned,
        calculated,
        // calculate,
    }
}